import React from 'react';
import { Link } from 'react-router-dom';
import styles from './SupportPage.module.css';
import termsStyles from './TermsPage.module.css';

const SUPPORT_EMAIL = 'beryl@berylrecoverybuddy.com';

const TOPICS = [
  'Trouble logging in',
  'Subscription or account issues',
  'Bugs or crashes',
  'Data syncing problems',
  'Feature requests',
  'Feedback and suggestions',
];


export default function SupportPage() {
  return (
    <div className={termsStyles.container}>
      <Link to="/settings" className={termsStyles.backLink}>
        ← Back to Settings
      </Link>

      <div className={termsStyles.header}>
        <h1 className={termsStyles.title}>Beryl Support</h1>
        <p className={termsStyles.date}>We're here to help</p>
      </div>

      <div className={termsStyles.content}>

        {/* Welcome */}
        <section className={termsStyles.section}>
          <p>
            Welcome to Beryl Support. Beryl is a recovery companion app designed to help people track
            injuries, rehabilitation, recovery progress, symptoms, exercises, scans, and overall
            wellbeing throughout their recovery journey.
          </p>
        </section>

        {/* Contact */}
        <section className={termsStyles.section}>
          <h2>Get in Touch</h2>
          <p>
            If you need help using the app, experience a bug, or have questions or feedback, please contact:
          </p>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className={styles.emailLink}
          >
            {SUPPORT_EMAIL}
          </a>
          <p style={{ marginTop: '12px' }}>We aim to respond within 2–3 business days.</p>
        </section>

        {/* Common Topics */}
        <section className={termsStyles.section}>
          <h2>Common Support Topics</h2>
          <ul className={styles.topicList}>
            {TOPICS.map((t) => (
              <li key={t} className={styles.topicItem}>
                <a
                  href={`mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(t)}`}
                  className={styles.topicLink}
                >
                  {t}
                </a>
              </li>
            ))}
          </ul>
        </section>

        {/* Privacy */}
        <section className={termsStyles.section}>
          <h2>Privacy & Data</h2>
          <p>
            Beryl takes user privacy seriously. Health and recovery information entered into the
            app is intended only for personal recovery tracking and support purposes.
          </p>
          <p style={{ marginTop: '12px' }}>
            For privacy-related questions or requests, please contact{' '}
            <a href={`mailto:${SUPPORT_EMAIL}`} className={styles.inlineLink}>{SUPPORT_EMAIL}</a>
          </p>
          <div className={styles.legalLinks}>
            <Link to="/privacy" className={styles.legalLink}>Privacy Policy →</Link>
            <Link to="/disclaimer" className={styles.legalLink}>Medical Disclaimer →</Link>
          </div>
        </section>

        {/* Closing */}
        <section className={styles.closingSection}>
          <p>Thank you for using Beryl. We hope it supports your recovery journey. 🤎</p>
        </section>

      </div>
    </div>
  );
}
